class createContact {
    constructor($state) {

        this.key = 'create-contact';
        this.title = 'Add New   ';
        this.level = 'highlight';
        this.icon = 'plus-circle';
        this.order = 10;
        this.state = $state;
    }

    action(payload, store) {
        return this.state.go('app.contacts.create', {store: store});
    }

}

angular
    .module('festzelt-os.contacts')
    .factory('createContact', [
        '$state',
        $state => new createContact($state)
    ]);



// WEBPACK FOOTER //
// ./src/app/pages/contacts/workflows/list-view/create-contact.js